import React, { useState, useEffect, useRef } from "react";
import Header from './components/Header';
import Form from './components/Form';
import AdvanceMode from './components/AdvanceMode';
import GenerateSection from './components/GenerateSection';

const App = () => {
  const [isAdvOpen, setIsAdvOpen] = useState(false);
  const [errorsActivated, setErrorsActivated] = useState(false);
  const [isNavMenuOpen, setIsNavMenuOpen] = useState(false);
  const errorsRef = useRef(null);
  const textareaRef = useRef(null);
  const addDepsRef = useRef(null);
  const copiedRef = useRef(null);

  const isValidVersion = (version) => {
    const regex = /^\d+\.\d+\.\d+$/;
    return regex.test(version);
  }
  
  const isValidUUID = (uuid) => {
    const uuidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
    return uuidPattern.test(uuid);
  };
  
  const scrollToTarget = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  const displayErrors = () => {
    const errors = forms.flatMap((form) => {
      if (form.type === 'required') {
        const requiredErrors = [];
        if (form.name === '') {
          requiredErrors.push('• Required Name is missing');
        }
        if (form.selectedOpt === '') {
          requiredErrors.push('• Put the required Pack Type');
        }
        if (!isValidVersion(form.version)) {
          requiredErrors.push('• Invalid required Version Format');
        }
        return requiredErrors;
      } else if (form.type === 'dependency' && isAdvOpen) {
        const dependencyErrors = [];
        if (form.selectedOpt === '') {
          dependencyErrors.push(`• Put a Pack Type in Dependency [ ${form.id} ]`);
        }
        if (!isValidUUID(form.uuid)) {
          dependencyErrors.push(`• Invalid or missing UUID in Dependency [ ${form.id} ]`);
        }
        if (!isValidVersion(form.version)) {
          dependencyErrors.push(`• Invalid or missing Version Format in Dependency [ ${form.id} ]`);
        }
        return dependencyErrors;
      }
      return [];
    });
    
    if (errors.length > 0) {
      return errors.map((error, index) => <p key={index}>{error}</p>);
    } else {
      return null;
    }
  };
  
  const [forms, setForms] = useState([
      {
        id: 'r',
        type: 'required',
        name: '',
        selectedOpt: '',
        description: '',
        version: '1.0.0'
      }, {
        id: 'm',
        type: 'metadata',
        name: '',
        link: ''
      }
  ]);
  
  return (
    <div className="App">
      <div ref={copiedRef} className="copied">
        <p>Copied</p>
      </div>
      <Header />
      <main>
        <section className="container section required-section children-spacing">
          <Form id="r" type="required" forms={forms} setForms={setForms} isAdvOpen={isAdvOpen} setIsAdvOpen={setIsAdvOpen} textareaRef={textareaRef} addDepsRef={addDepsRef} errorsRef={errorsRef} setErrorsActivated={setErrorsActivated} displayErrors={displayErrors} scrollToTarget={scrollToTarget} isValidVersion={isValidVersion}/>
        </section>
        
        <AdvanceMode forms={forms} setForms={setForms} isAdvOpen={isAdvOpen} setIsAdvOpen={setIsAdvOpen} textareaRef={textareaRef} addDepsRef={addDepsRef} errorsRef={errorsRef} setErrorsActivated={setErrorsActivated} displayErrors={displayErrors} scrollToTarget={scrollToTarget} />
        <GenerateSection forms={forms} setForms={setForms} isAdvOpen={isAdvOpen} setIsAdvOpen={setIsAdvOpen} errorsActivated={errorsActivated} setErrorsActivated={setErrorsActivated} textareaRef={textareaRef}
          addDepsRef={addDepsRef}
          copiedRef={copiedRef} 
          errorsRef={errorsRef}
          displayErrors={displayErrors}
          scrollToTarget={scrollToTarget} />
      </main>
    </div>
  );
}

export default App;






// remove some unnecessary query parameters from URL
const url = new URL(window.location.href);
url.searchParams.delete('PC');
url.searchParams.delete('fbclid');
window.history.replaceState({}, document.title, url.pathname + url.search);
